import React, { useContext } from 'react';

import LandingPageBody from './landing-page-body';
import Footer from '../footer';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';

const LandingPage = () => {
    const { setStep } = useContext(RequestAccessFormContext);

    const handleNextStep = () => {
        setStep(1);
    };

    return (
        <>
            <LandingPageBody />
            <Footer
                buttonLabel="app.request.access.public.landingpage.submit.button"
                buttonProps={{ onClick: handleNextStep }}
            />
        </>
    );
};

export default LandingPage;
